fragment DefaultImageSrcset on AssetInterface {
    defaultSrc: url @transform(width: 520, quality: 84)

    w1920: url @transform(width: 1920)
    w1440: url @transform(width: 1440)
    w1260: url @transform(width: 1260)
    w980: url @transform(width: 980)
    w768: url @transform(width: 768)
    w520: url @transform(width: 520)
    w380: url @transform(width: 380)
    w320: url @transform(width: 320)
    w200: url @transform(width: 200)

    w1920_webp: url @transform(width: 1920, format: "webp", quality: 84)
    w1440_webp: url @transform(width: 1440, format: "webp", quality: 84)
    w1280_webp: url @transform(width: 1280, format: "webp", quality: 84)
    w980_webp: url @transform(width: 980, format: "webp", quality: 84)
    w768_webp: url @transform(width: 768, format: "webp", quality: 84)
    w520_webp: url @transform(width: 520, format: "webp", quality: 84)
    w380_webp: url @transform(width: 380, format: "webp", quality: 84)
    w320_webp: url @transform(width: 320, format: "webp", quality: 84)
    w200_webp: url @transform(width: 200, format: "webp", quality: 84)

#    w1920_avif: url @transform(width: 1920, format: "avif")
#    w1440_avif: url @transform(width: 1440, format: "avif")
#    w1280_avif: url @transform(width: 1280, format: "avif")
#    w980_avif: url @transform(width: 980, format: "avif")
#    w768_avif: url @transform(width: 768, format: "avif")
#    w520_avif: url @transform(width: 520, format: "avif")
#    w380_avif: url @transform(width: 380, format: "avif")
#    w320_avif: url @transform(width: 320, format: "avif")
}
